import { Header, Text } from '@rbilabs/universal-components';

import { LayoutContainer } from 'components/layout/styled';

export const Wrapper = LayoutContainer.withConfig({
  justifyContent: 'center',
  alignItems: 'center',
});

export const HeadingText = Header.withConfig({
  textAlign: 'center',
});

export const BodyText = Text.withConfig({
  fontSize: 'md',
  textAlign: 'center',
  marginBottom: '$4',
});
